module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gameApp"
    }
  }, [_c('section', [(!_vm.isGameStarted || _vm.isPaused) ? _c('game-menu', {
    on: {
      "initGame": _vm.nextLevel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isGameStarted) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPaused),
      expression: "!isPaused"
    }],
    staticClass: "game-container"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "main-menu-btn btn",
    on: {
      "click": _vm.pauseGame
    }
  }, [_vm._v("Main Menu")]), _vm._v(" "), _c('scores-levels'), _vm._v(" "), (_vm.$store.state.isAllWordsFound) ? _c('level-cleared', {
    on: {
      "nextLevel": _vm.nextLevel
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isAllWordsFound) ? _c('div', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "drop-area"
    }
  }, _vm._l((_vm.gameData.c.ques.length), function(i) {
    return _c('letter', {
      key: i - 1,
      staticClass: "inactive",
      attrs: {
        "data": _vm.dropAreaData(i),
        "index": i - 1,
        "data-id": _vm.dropArea[i - 1]
      },
      nativeOn: {
        "click": function($event) {
          _vm.letterDown($event, _vm.dropArea[i - 1])
        }
      }
    })
  })), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "q-area"
    }
  }, _vm._l((_vm.gameData.c.ques), function(data, i) {
    return _c('letter', {
      key: i,
      attrs: {
        "data": data,
        "index": i,
        "data-id": data
      },
      nativeOn: {
        "click": function($event) {
          _vm.letterUp($event, data)
        }
      }
    })
  })), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "cloners"
    }
  }), _vm._v(" "), _c('controls', {
    on: {
      "bringDownAll": _vm.letterAction,
      "clearAction": _vm.clearAction,
      "setError": _vm.setError
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.$store.state.showNextLevel) ? _c('p', {
    staticClass: "next-level-button"
  }, [_vm._v("Skip this level "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextLevel
    }
  }, [_vm._v("Next Level")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('answers'), _vm._v(" "), (_vm.showHowToPlayModal === true) ? _c('div', {
    staticClass: "how-to-play"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("How To Play")]), _vm._v(" "), _c('p', [_vm._v("There are 5 jumbled letters. Arrange the letters to form possible WORDS.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Use <keyboard> (A-Z) keys to move letter UP or DOWN and use <ENTER> key to submit the word.")]), _vm._v(" "), _c('p', [_vm._v("At-least one 5 letter word is required to go next level.")]), _vm._v(" "), _c('p', [_vm._v("Find all words to earn bonus points " + _vm._s(_vm.$store.state.bonusScore) + ".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showHowToPlayModal = false
      }
    }
  }, [_vm._v("Start")])])]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-logo"
  }, [_c('a', {
    attrs: {
      "href": "http://iamkumaran.github.io/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://iamkumaran.github.io/img/logo.png",
      "title": "Back To My Github Page"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Click on YELLOW balls to move letters up to form WORDS. "), _c('b', [_vm._v("<Submit>")]), _vm._v(" button will be enabled once there are 3 letters at top.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5357d798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 25
// module chunks = 0